// column-width.service.ts

import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ColumnWidthService {
    static columnWidthSubject = new Subject<{ [key: string]: number }>();
    static columnHeightSubject = new Subject< number >();

    columnWidth$ = ColumnWidthService.columnWidthSubject.asObservable();
    columnHeight$ = ColumnWidthService.columnHeightSubject.asObservable();

    static setColumnMinWidth(columnKey: string, minWidth: number): void {
        ColumnWidthService.columnWidthSubject.next({ [columnKey]: minWidth });
    }

    static setColumnMinHeight(minHeight: number): void {
        ColumnWidthService.columnHeightSubject.next(minHeight);
    }
}
